export default __webpack_public_path__ + "49481ef2f12f26af4f12fe27fc6682a2f8c2e4c3b551547524d0cf5b60032338.svg";